import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useController } from 'react-hook-form';
import SimpleSelect from '../simple-select';
import FieldStatus from '../field-status';
import { SIMPLE_SELECT_PROPS } from '../simple-select/types';
import noop from '../../../utils/noop';

const defaultRules = {};

const SimpleSelectField = ({
  name,
  options,
  control,
  rules = defaultRules,
  onChange = noop,
  onBlur = noop,
  ...otherProps
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (option) => {
      field.onChange(option.value);
      if (onChange) onChange(option);
    },
    [field, onChange]
  );

  const handleBlur = useCallback(
    (...arg) => {
      field.onBlur(...arg);
      if (onBlur) onBlur(...arg);
    },
    [field, onBlur]
  );

  let defaultValue;

  if (options[0].options) {
    defaultValue = options[0].options.find(({ value }) => value === field.value) || null;
  } else {
    defaultValue = options.find(({ value }) => value === field.value) || null;
  }

  return (
    <React.Fragment>
      <SimpleSelect
        {...otherProps}
        onChange={handleChange}
        onBlur={handleBlur}
        options={options}
        defaultValue={defaultValue}
        name={field.name}
        invalid={fieldState.invalid}
      />
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </React.Fragment>
  );
};

SimpleSelectField.propTypes = {
  ...SIMPLE_SELECT_PROPS,
  name: PropTypes.string.isRequired,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default SimpleSelectField;
